import React, { useEffect, useMemo, useState } from "react";
import { Form, Empty, Collapse } from "antd";
import { renderFieldFormItem } from "../help";
import styles from "../index.module.less";
import { filterTree, traverseTree } from "@/utils/tree";
import useStore from "@/pages/documentCompile/store/useStore";
import { isNotUndefined } from "@/utils/tools";
import { FieldKindEnum } from "@/pages/documentCompile/domain/type";
import { ArrowRightOutlined, SearchOutlined } from "@ant-design/icons";

interface TreeDomainFormProps {
    settingDomainFormData: any;
    domainTreeData: any[];
    usedDomainDataMap: any;
    form: any;
    handleFormValuesChange: (changedFields: any, allFields: any) => void;
    handleSearch: (item: any, parentItem?: any) => void;
}

export default function TreeDomainForm({
    settingDomainFormData,
    domainTreeData,
    usedDomainDataMap,
    form,
    handleFormValuesChange,
    handleSearch,
}: TreeDomainFormProps) {
    const [activeKey, setActiveKey] = useState<string[]>([])
    const getPurDomainTreeData = useStore.getState().getPurDomainTreeData
    const usedDomainDocDataMap = useStore.getState().usedDomainDocDataMap
    console.log("settingDomainFormData", settingDomainFormData)
    // 构建树形结构数据，只包含已使用的字段
    // const treeFormData = useMemo(() => {
    //     const result: any[] = [];
    //     domainTreeData.forEach((group) => {
    //         const groupChildren: any[] = [];
    //         const level2Groups: { [key: string]: any } = {};
    //         if (group.children) {
    //             group.children.forEach((field: any) => {
    //                 // 检查字段是否被使用
    //                 if (!field.noField && field.isDomain && usedDomainDataMap[field.fieldTag]) {
    //                     if (field.children && field.children.length > 0) {
    //                         // 这是一个有子字段的复合字段，作为二级分组
    //                         const usedChildren = field.children.filter((child: any) =>
    //                             !child.noField && child.isDomain && usedDomainDataMap[child.fieldTag]
    //                         );

    //                         if (usedChildren.length > 0) {
    //                             level2Groups[field.key] = {
    //                                 ...field,
    //                                 children: usedChildren
    //                             };
    //                         }
    //                     } else {
    //                         // 这是一个普通字段
    //                         groupChildren.push(field);
    //                     }
    //                 }
    //             });
    //         }

    //         // 如果有字段或二级分组，添加到结果中
    //         if (groupChildren.length > 0 || Object.keys(level2Groups).length > 0) {
    //             result.push({
    //                 ...group,
    //                 children: groupChildren,
    //                 level2Groups: level2Groups
    //             });
    //         }
    //     });

    //     return result;
    // }, [domainTreeData, usedDomainDataMap])
    const treeFormData = useMemo(() => {
        // const result: any[] = [];
        // const root = domainTreeData?.[0]
        // if (!root?.children) return []
        // root.children.forEach((group) => {
        //     if (group.groupName) {
        //         result.push(group)
        //     }
        // })
        // return result

        const purDomainTreeData = getPurDomainTreeData()
        const newDomainData = filterTree(purDomainTreeData, (node) => {
            return node.fieldTag && isNotUndefined(usedDomainDocDataMap[node.fieldTag])
        })
        return newDomainData
    }, [domainTreeData?.length, usedDomainDocDataMap])

    useEffect(() => {
        const activeKey = treeFormData.map((item) => item.id || item.key)
        const firstKey = activeKey[0]
        if (firstKey) {
            setActiveKey([firstKey])
        }
    }, [treeFormData?.length])

    console.log("treeFormData", treeFormData)
    if (treeFormData.length === 0) {
        return (
            <div className={styles.formContainer}>
                <div className={styles.emptyContainer}>
                    <Empty description="当前文档未引用字段域" />
                </div>
            </div>
        );
    }


    const collapseItems = useMemo(() => {
        return treeFormData.map((group) => ({
            key: group.id || group.key,
            label: <span className={styles.collapse2Label}>{group.groupName || group.fieldName}</span>,
            children: (
                <>
                    {/* 渲染一级字段 */}
                    {group.children?.map((item: any) => (
                        <React.Fragment key={item.key || item.fieldTag}>
                            <Form.Item
                                hidden={item.kind === FieldKindEnum.COMPLEX}
                                key={item.key + 'form'}
                                name={item.fieldTag}
                                label={item.fieldName}
                                rules={[]}
                            >
                                {renderFieldFormItem(item, false, handleSearch)}
                            </Form.Item>
                            {/* 渲染二级分组（嵌套折叠面板） */}
                            {Object.keys(item.children || []).length > 0 && item.kind === FieldKindEnum.COMPLEX && (
                                <Collapse
                                    className={styles.collapse2}
                                    size="small"
                                    key={(item.key || item.fieldTag) + 'collapse'}
                                    ghost
                                    // expandIcon={() => null}
                                    // expandIconPosition="end"
                                    items={[{
                                        key: item.key || item.fieldTag,
                                        label: <span className={styles.collapse2Label}>{item.fieldName} <SearchOutlined style={{ padding: 4 }} onClick={(e) => {
                                            e.stopPropagation()
                                            handleSearch(null, item)
                                        }} /></span>,
                                        children: item.children?.map((item2: any) => (
                                            <Form.Item
                                                key={item2.key || item2.fieldTag}
                                                name={item2.fieldTag}
                                                label={item2.fieldName}
                                                rules={[]}
                                            >
                                                {renderFieldFormItem(item2, false, handleSearch)}
                                            </Form.Item>
                                        ))
                                    }]}
                                />
                            )}
                        </React.Fragment>
                    ))}


                </>
            )
        }));
    }, [treeFormData, handleSearch]);

    return (
        <div className={styles.formContainer}>
            <Form
                size="small"
                form={form}
                onValuesChange={handleFormValuesChange}
                layout="vertical"
            >
                <Collapse activeKey={activeKey} size="small" items={collapseItems} onChange={setActiveKey} />
            </Form>
        </div>
    );
}